import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { TableModule } from 'primeng/table';
import { Button } from 'primeng/button';

import { CanDirective } from '@/core/permissions/can.directive';
import type { PermissionInput } from '@/core/permissions/permission.model';

export interface CensuraPublicaItem {
    dtInicio: string;
    dtFim: string;
    observacao?: string;
    documentoBase64?: string | null;
    possuiAnexo?: boolean;
    inDivulgaPortal?: string | null;
}

@Component({
    selector: 'app-censura-publica',
    standalone: true,
    imports: [TableModule, Button, CanDirective],
    templateUrl: './censura-publica.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
/** Seção (tabela) de censuras públicas do médico. */
export class CensuraPublicaComponent {
    modoEdicao = input<boolean>(false);
    censuras = input<CensuraPublicaItem[]>([]);
    loadingCensurasPublicas = input<boolean>(false);
    erroCensurasPublicas = input<string | undefined>();
    salvandoCensuraPublica = input<boolean>(false);
    /** Role de escrita da censura (família própria no backend); o host passa a do catálogo. */
    roleEditar = input<PermissionInput | undefined>();
    uf = input<string | undefined>();

    abrirDialog = output<void>();
    editar = output<CensuraPublicaItem>();
    visualizar = output<CensuraPublicaItem>();
}
